import type { DocumentPickerAsset } from 'expo-document-picker';
import { Platform, type PlatformOSType } from 'react-native';

export type PickedFile = File | DocumentPickerAsset;

export interface PickedFileDescriptor {
  name: string;
  size?: number;
}

const isWebFile = (file: PickedFile, platform: PlatformOSType): file is File => platform === 'web';

export function buildFileFormData(
  file: PickedFile,
  platform: PlatformOSType = Platform.OS,
): FormData {
  const formData = new FormData();

  if (isWebFile(file, platform)) {
    formData.append('file', file);
    return formData;
  }

  formData.append('file', {
    uri: file.uri,
    name: file.name,
    type: file.mimeType,
  } as unknown as Blob);
  return formData;
}

buildFileFormData.describe = (
  file: PickedFile,
  platform: PlatformOSType = Platform.OS,
): PickedFileDescriptor =>
  isWebFile(file, platform)
    ? { name: file.name, size: file.size }
    : { name: file.name, size: file.size ?? undefined };
